import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import AverageRating from './AverageRating';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './ProfileTemplates.module.scss';

interface ProfileTemplatesHeaderProps {
  isMobileView: boolean;
  averageRating: number;
  totalTemplatesLength: number;
  loadedTemplatesLength: number;
}

const ProfileTemplatesHeader: React.FC<ProfileTemplatesHeaderProps> = ({
  isMobileView,
  averageRating,
  totalTemplatesLength,
  loadedTemplatesLength,
}) => {
  const { t } = useTranslation();

  if (isMobileView) {
    return (
      <Box gap="6px">
        <Text size="small" weight="normal" dataHook="templates-title">
          {t('profile-page-templates-section-header-mobile')}
        </Text>
        <AverageRating
          averageRating={averageRating}
          templatesLength={totalTemplatesLength}
          isMobileView={isMobileView}
        />
      </Box>
    );
  }
  return (
    <>
      <Box gap="4px">
        <Text size="medium" weight="bold" dataHook="templates-title">
          {t('profile-page-templates-section-header')}
        </Text>
        <Text
          size="medium"
          weight="bold"
          className={s.loadedTemplatesLength}
          dataHook="loaded-templates-length"
        >
          {totalTemplatesLength}
        </Text>
        <Box marginLeft="12px">
          <AverageRating
            averageRating={averageRating}
            templatesLength={0} // TODO: This was meant to be the total ratings amount but currently we don't have that
          />
        </Box>
      </Box>
    </>
  );
};

export default ProfileTemplatesHeader;
